/* This component CREATES one entry for the historys collection in MongoDB.
   As the entry is being CREATED, it should then activate the HistoryRead component
   to show the entry as it is being built. */

import React, { useState }                      from 'react'
import axios                                    from 'axios'
import Box                                      from "@material-ui/core/Box"
import {
   Button,
   Grid,
   TextField,
   TextareaAutosize,
   Typography }                                 from '@material-ui/core'
import GuestBioHistoryEntryReadComponent        from './GuestBioHistoryEntryReadComponent'
import GuestBioSearchComponent                  from './GuestBioSearchComponent'
import PhotoSearchComponent                     from './PhotoSearchComponent'
import RadioOptionComponent                     from '../Components/RadioOptionComponent'
import {
   CLIENT_PUBLIC_TOKEN,
   historyRadioOptions
}                                               from '../config'
import { node_server }                          from '../Helpers'

const HistoryCreateComponent = () => {

   /* entry here is used as the text data for a Text or Bullet entry. Other components use entry
      as the entire object from the MongoDB histories collection. historyEntry serves that purpose
      here. Unfortunate disconnect. */
   const [ entry,                               setEntry                         ]  =  useState('')
   const [ entryType,                           setEntryType                     ]  =  useState('')
   const [ historyEntry,                        setHistoryEntry                  ]  =  useState({})
   const [ id,                                  setId                            ]  =  useState('')
   const [ linkCaption,                         setLinkCaption                   ]  =  useState('')
   const [ linkId,                              setLinkId                        ]  =  useState('')
   const [ photoId,                             setPhotoId                       ]  =  useState('')
   const [ showPhotoSearchComponent,            setShowPhotoSearchComponent      ]  =  useState(true)
   const [ title,                               setTitle                         ]  =  useState('')
   const [ width,                               setWidth                         ]  =  useState(0)

   const changeEntry = (e) => {
      setEntry(e.target.value)
   }

   const changeLinkCaption = (e) => {
      setLinkCaption(e.target.value)
   }

   const changeTitle = (e) => {
      setTitle(e.target.value)
   }

   const changeWidth = (e) => {
      setWidth(e.target.value)
   }

   const getOption = (o) => {
         switch (o) {
         case 'Bullet':
            setEntryType('bullet')
         break
         case 'Link':
            setEntryType('link')
         break
         case 'Photo':
            setEntryType('photo')
         break
         case 'Text':
            setEntryType('text')
         break
         default:
         break
      }
   }

   const handleAddPhoto = ({id, filename}) => {
      setPhotoId(id)
      setShowPhotoSearchComponent(false)
   }

   const handleClickGuestBio = (guestBioId) => {
      setLinkId(guestBioId._id)
   }

   const handleSubmit = async () => {

      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      if (id === '') {
         axios.post( node_server + 'history', 
         {
            title
         })
         .then( res => {
            if (res.data.msg === 'good_operation') {
               /* setHistoryEntry needs to run before setId so that GuestBioHistoryEntryReadComponent gets the correct data */
               setHistoryEntry(res.data.entryToDB)
               setEntry('')
               setId(res.data.entryToDB._id)
            }
            else {
               // handleSnackBar({ msg: 'No photo yet in the database.', type:'error' })
            }
         })
         .catch( ( error, msg ) => {
            console.error('error and msg are', error, msg)
         } )
      }
      else {
         axios.put(node_server + 'history', {
            entry,
            entryType,
            id,
            photoId,
            width,
            link: {
               id: linkId,
               caption: linkCaption,
               collectionName: 'histories',
               link: ''
            }
         })
         .then( res => {
            if (res.data.msg === 'good_operation') {
               setHistoryEntry(res.data.entryToDB)
               setEntry('')
               setLinkCaption('')
            }
         })
         .catch( ( error, msg ) => {
            console.error('error and msg are', error, msg)
         } )
      }
   }

   return (
      <Box style={{ marginTop: '6rem', marginBottom: '1rem' }}>
         <Grid>
            <Typography variant='h5'>
               Create a Historical Entry
            </Typography>
         </Grid>

         {id === ''
            ?
               null
            :
               <GuestBioHistoryEntryReadComponent entry={historyEntry} />
         }

         <Grid>
            {id === ''
               ?
                  <Grid item xs={12} style={{ marginTop: '1rem' }} >
                     <TextField name='history-create-title' label="Title" variant='outlined' style={{ width: '90%' }} onChange={changeTitle} />
                  </Grid>
               :
                  <Grid>
                     <RadioOptionComponent getOption={getOption} options={historyRadioOptions} />
                     <TextareaAutosize data-testid='history-text' label="Bullet / Link / Text" name="history-text" minRows={5} style={{ width: "90%", fontSize: "1rem" }} onChange={changeEntry} value={entry} />
                  </Grid>
            }

            <Grid>
               { entryType === 'photo' && showPhotoSearchComponent
                  ?
                     <Grid>
                        <TextField data-testid="history-create-photo-width" name='history-create-photo-width' label="Photo Width %" variant='outlined' style={{ width: '40%' }} onChange={changeWidth} />
                     </Grid>
                  :
                     null
               }
               { entryType === 'photo' && showPhotoSearchComponent ? <PhotoSearchComponent buttonLabel={'Add to History Entry'} handleAddPhoto={handleAddPhoto} /> : null }
               
            </Grid>

            { entryType === 'link' ? <GuestBioSearchComponent handleClickGuestBio={handleClickGuestBio} /> : null }

            { entryType === 'link'
               ?
                  <Grid>
                     <TextField data-testid="history-create-link-caption" name='history-create-link-caption' label="Link Caption" variant='outlined' style={{ width: '40%' }} onChange={changeLinkCaption} />
                  </Grid>
               :
                  null
            }

            {title.length > 0
               ?
                  <Grid item xs={2} style={{ marginTop: '1rem' }}>
                     <Button data-testid='history-create-submit' variant='contained' color='primary' onClick={handleSubmit}>Submit</Button>
                  </Grid>
               :
                  <Grid item xs={2} style={{ marginTop: '1rem' }}>
                     <Button variant='contained' color='primary' disabled>Submit</Button>
                  </Grid>
            }
         </Grid>
      </Box>
   )
}

export default HistoryCreateComponent
